export default function useListingFunctions() {

    // function for RFP counting of filters
    function filterCountFunction(values) {
        let count = 0
        if(Object.keys(values).length <= 0) count = 0
        else {
            if(values.department?.length > 0) count = count + 1
            if(values.branch?.length > 0) count = count + 1
            if(values.payee?.length > 0) count = count + 1
            if(values.requestor?.length > 0) count = count + 1
            if(values.status?.length > 0) count = count + 1
        }
        return count
    }

    // Returns all value selected from filter and count
    // Output: "status" => "status1": 0, "status2": 1
    function listAndCountPerValue(list, filters) {
        let keyMapper = {
            department: 'dept_code',
            branch: 'branch_code',
            payee: 'payee_code',
            requestor: 'requestor_code',
            status: 'status_code'
        }

        let data = {}
        for(const key of Object.keys(filters)) {
            if(Array.isArray(filters[key]) && Object.keys(filters[key]).length > 0) {
                let filterValueArray = {}
                filters[key].forEach(value => {
                    filterValueArray[value] = list.filter((entry) => {
                        return entry[keyMapper[key]] === value
                    }).length
                })
                let field = key.toUpperCase()[0] + key.slice(1).toLowerCase()
                data[field] = filterValueArray
            }
        }

        return data
    }

    // returns count of department in listing
    // Output: "DEPT": 0
    // values => array of keys to compare
    function returnCountInList(list, keyValue, values) {
        let data = {}
        values.forEach((val) => {
            let count = 0
            for(const key of Object.keys(list)) {
                if(list[key][keyValue] === val) count = count + 1
            }
            data[val] = count
        })

        return data
    }

    function returnValue(list, key, value, returnKey = null) {
        let data = list.find(datum => datum[key] === value)
        if(data) {
            return returnKey ? data[returnKey] : data
        }
        return ''
    }

    function base64encoding(data) {
        // stringify data
        let stringData = JSON.stringify(data)
        return btoa(stringData)
    }

    function base64decoding(encodedData) {
        return atob(encodedData)
    }

    return {
        filterCountFunction,
        listAndCountPerValue,
        returnCountInList,
        returnValue,
        base64encoding,
        base64decoding
    }
}